import { Topic } from './enums';

export class Message<T> {
  body: T;
  topic: Topic;
  id: string;
}
